import { schema } from "normalizr";

const aufbauBereichSchema = new schema.Entity(
  "aufbau_bereich",
  {},
  { idAttribute: "id" }
);

export { aufbauBereichSchema };
